import { URI } from '@fiverr-private/futile';
import pathfinder from '@fiverr-private/pathfinder';

export const getLinkToSellerPage = (sellerName, source = '') => new URI(pathfinder('short_user', { id: sellerName }))
    .addParams({ source })
    .toString();
